import { State } from '../../../store/state';

export const tokenSelector = (state: State) => state.auth.token;
export const refreshTokenSelector = (state: State) => state.auth.refreshToken;
export const errorCodeSelector = (state: State) => state.auth.errorCode;
